export default __webpack_public_path__ + "images/5f97b9eff8f543f524d2bb85aad7adc1.svg";